import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

export const signInStep2UseReceivedCodeToLogin = createAppAsyncThunk(
  'auth/signInStep2UseReceivedCodeToLogin',
  async (receivedCode: string, { extra: { authGateway, snackbarGateway } }) => {
    const result = await authGateway.validateSignInAuthCode(receivedCode);
    if (result.authorized == false) {
      snackbarGateway.error(translate('Login.Message.error'));
    }
    return result;
  },
);
